//导入封装好的新的axios
import request from '@/request/index'
//查询呼叫日志列表
export function getCallLogList(params) {
    return request({
        url: '/' + params.rgn +'/site/events/page',
        method: 'get',
        params,
    })
}

//导出
export function getCallLogExport(params) {
    return request({
        url: '/' + params.rgn +'/site/events/getExportUrl',
        method: 'get',
        params,
    })
}


export default { getCallLogList, getCallLogExport}